import http from '@/services/http';
import apiEndpoints from '@/services/apiEndpoints';

const getDefaultState = () => {
  return {
    user: {},
    token: '',
  };
};

const state = getDefaultState();
const getters = {
  user (state) {
    return state.user;
  },
  token (state) {
    return state.token;
  },
};
const mutations = {
  SET_USER (state, { token, user }) {
    state.token = token;
    state.user = user;
  },
  UNSET_USER (state) {
    state.token = '';
    state.user = {};
  },
};
const actions = {
  async login ({ commit, dispatch }, payload) {
    console.log("modules.auth.js 画面ログイン");
    const resLogin = await http.post(apiEndpoints.login, payload);
    const { status, data } = resLogin;

    if (status) {
      const { token, user } = data.result;

      commit('SET_USER', {
        token,
        user,
      });
      await dispatch('permissions/getPermissions', null, { root: true })

      return {
        status: true,
      };
    } else {
      return {
        status: false,
        errors: data.errors,
        code: data.code,
        message: data.message,
      };
    }
  },
  async logout ({ commit }, payload) {
    console.log("modules.auth.js ログアウト");

    // TODO: local 以外
    if (process.env.VUE_APP_IS_USE_SAML_AUTH === 'true' && state.token !== '') {
      // API 側のログアウト
      const resLogout = await http.post(apiEndpoints.slo, payload);

      // 仕組みは用意したが、GMO トラストログインでシングルログアウトに対応していないため、ログアウトの連携は行わない
      //const { status, data } = resLogout;
      //const redirectUrl = data.result.logoutURL;
      //console.log('redirectUrl = ' + redirectUrl);
    }

    commit('UNSET_USER');
    commit('options/UNSET_OPTION_TABLES', null, { root: true })
    commit('permissions/UNSET_PERMISSIONS', null, { root: true })
  },
  async ssoLogin ({ commit, dispatch }, payload) {
    console.log("modules.auth.js SSOログイン");

    // API でログインユーザー情報は改めて取り直すので、アクセストークンとダミーのユーザーオブジェクトを一旦保存しておく
    const token = payload.token;
    const dummyuser = {};
    commit('SET_USER', {
      token,
      dummyuser
    });

    // API 側でログイン失敗している場合は token, user が空
    if (token === '') {
      return {
        status: false,
      }
    }

    // アクセストークンを使用して、API でログインユーザー情報を取得する
    const loginUserInfo = await http.get(apiEndpoints.get_user_info, {});
    const { status, data } = loginUserInfo;

    if (status) {
      const user = data.result;
      console.log(user);

      // 取得結果でローカルストレージを更新
      commit('SET_USER', {
        token,
        user
      });

      // ログインユーザーの権限の取得
      await dispatch('permissions/getPermissions', null, { root: true })
    } else {
      // ログインユーザー情報の取得失敗
      return {
        status: false,
      }
    }

    return {
      status: true,
    };
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
